"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfDrawingTextBodyPropertiesHelper = void 0;
var unit_converter_1 = require("@devexpress/utils/lib/class/unit-converter");
var common_1 = require("@devexpress/utils/lib/utils/common");
var rtf_drawing_keywords_1 = require("../../../../translation-table/rtf-drawing-keywords");
var RtfDrawingTextBodyPropertiesHelper = (function () {
    function RtfDrawingTextBodyPropertiesHelper(shapePropertiesInfo) {
        this.shapePropertiesInfo = shapePropertiesInfo;
    }
    RtfDrawingTextBodyPropertiesHelper.prototype.applyProperties = function (properties) {
        this.processInsetLeft(properties);
        this.processInsertRight(properties);
        this.processInsertTop(properties);
        this.processInsetBottom(properties);
        this.processFitShapeToText(properties);
        this.processWrapText(properties);
    };
    RtfDrawingTextBodyPropertiesHelper.prototype.processInsetLeft = function (properties) {
        this.shapePropertiesInfo.trySetProperty(rtf_drawing_keywords_1.RtfDrawingKeywords.TextLeft, function (value) { return properties.leftMargin = unit_converter_1.UnitConverter.emuToTwips(value); });
    };
    RtfDrawingTextBodyPropertiesHelper.prototype.processInsertRight = function (properties) {
        this.shapePropertiesInfo.trySetProperty(rtf_drawing_keywords_1.RtfDrawingKeywords.TextRight, function (value) { return properties.rightMargin = unit_converter_1.UnitConverter.emuToTwips(value); });
    };
    RtfDrawingTextBodyPropertiesHelper.prototype.processInsertTop = function (properties) {
        this.shapePropertiesInfo.trySetProperty(rtf_drawing_keywords_1.RtfDrawingKeywords.TextTop, function (value) { return properties.topMargin = unit_converter_1.UnitConverter.emuToTwips(value); });
    };
    RtfDrawingTextBodyPropertiesHelper.prototype.processInsetBottom = function (properties) {
        this.shapePropertiesInfo.trySetProperty(rtf_drawing_keywords_1.RtfDrawingKeywords.TextBottom, function (value) { return properties.bottomMargin = unit_converter_1.UnitConverter.emuToTwips(value); });
    };
    RtfDrawingTextBodyPropertiesHelper.prototype.processFitShapeToText = function (properties) {
        var fitShapeToText = this.shapePropertiesInfo.getPropertyOrNull(rtf_drawing_keywords_1.RtfDrawingKeywords.FitShapeToText);
        if (common_1.isDefined(fitShapeToText))
            properties.resizeShapeToFitText = fitShapeToText != 0;
        else
            properties.resizeShapeToFitText = false;
    };
    RtfDrawingTextBodyPropertiesHelper.prototype.processWrapText = function (properties) {
        this.shapePropertiesInfo.trySetProperty(rtf_drawing_keywords_1.RtfDrawingKeywords.WrapText, function (value) { return properties.wrapText = value; });
    };
    return RtfDrawingTextBodyPropertiesHelper;
}());
exports.RtfDrawingTextBodyPropertiesHelper = RtfDrawingTextBodyPropertiesHelper;
